"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = registerPooledObjectService;

var _LazyKeyStore = require("../store/LazyKeyStore");

function idIsValid(id) {
  return typeof id === 'string' || typeof id === 'number';
}

function idTransform(id) {
  return "" + id;
}

function registerPooledObjectService(_ref) {
  var actionTypePrefix = _ref.actionTypePrefix,
      fetcher = _ref.fetcher,
      fetchLimit = _ref.fetchLimit;
  return (0, _LazyKeyStore.registerLazyKeyService)({
    namespace: actionTypePrefix,
    fetch: fetcher,
    idIsValid: idIsValid,
    idTransform: idTransform,
    fetchLimit: fetchLimit
  });
}

module.exports = exports.default;